<template>
    <div class="rc-textarea-design">
      <label class="item-name"><i class="required" v-show="initComponent.properties.required">*</i>{{initComponent.name}}</label>
      <el-input :class="{onlyread:initComponent.properties.readonly}" :placeholder="initComponent.properties.placeholder" ref="textarea" type="textarea" disabled />
    </div>
</template>

<script>
import { componentMixin } from '../mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
export default {
  name: 'rc-textarea',
  props: ['initComponent'],
  mixins: [ componentMixin, heightMixin ],
  mounted () {
    this.initHeight(this.$refs.textarea.$el.children[0])
  },
  watch: {
    'initComponent.properties.height' (val) {
      this.initHeight(this.$refs.textarea.$el.children[0])
    }
  }
}
</script>

<style lang="scss">
.rc-textarea-design {
  height: initial;
  .el-textarea ,textarea {
    height: 100%;
  }
  .el-textarea.is-disabled .el-textarea__inner {
      background-color: #fff;
  }
  .el-textarea.onlyread .el-textarea__inner{
     background-color: #f5f7fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/components/textarea/rc-textarea.vue